import { render } from "./Thanks.vue?vue&type=template&id=52d1e403&scoped=true&ts=true"
import script from "./Thanks.vue?vue&type=script&lang=ts"
export * from "./Thanks.vue?vue&type=script&lang=ts"

import "./Thanks.vue?vue&type=style&index=0&id=52d1e403&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d1e403"]])

export default __exports__